import { SelectOption } from 'models';

export const CategoryOptions: SelectOption[] = [
  { value: 'Medicinska pomagala', label: 'Medicinska pomagala' },
  { value: 'Namještaj', label: 'Namještaj' },
  { value: 'Odjeća', label: 'Odjeća' },
  { value: 'Volonteri', label: 'Volonteri' },
];
